<div
  #tooltipElement
  class="entry-log-item"
  (click)="onClick()"
  [ngStyle]="{
    width: width + 'px',
    backgroundColor: categoryColor,
  }"
></div>
